import { Component } from '@angular/core';
import { input } from '@angular/core';

/** Direction a row moved relative to its position in the previous revision. */
export type RowOrderDirection = 'up' | 'down' | 'unchanged';

/**
 * Replaces the drag-handle icon in compare mode, showing which direction the row
 * moved relative to its position in the previous revision.
 *
 * Renders an up-arrow when the row moved earlier in the list, a down-arrow when it moved
 * later, and nothing when its position is unchanged.  Deleted/new rows are handled by the
 * parent (row background colour) — this component is not rendered for those cases.
 */
@Component({
  selector: 'app-row-order-indicator',
  templateUrl: './row-order-indicator.component.html',
  styleUrls: ['./row-order-indicator.component.scss'],
  standalone: false
})
export class RowOrderIndicatorComponent {
  /** Computed movement direction for this row. */
  direction = input<RowOrderDirection>('unchanged');
}
